<script setup lang="ts">
</script>

<template>
  <div class="landing-proxy">
    <NuxtPage />
  </div>
</template>

<style lang="scss" scoped>
.landing-proxy {
  font-family: AlsHauss, sans-serif;
  background: #fff;
}
</style>
